// extracted by mini-css-extract-plugin
export default {"container":"MeetingRoomSlotListItem_container__DRg1M","infoWrapper":"MeetingRoomSlotListItem_infoWrapper__QBqcE"};